import { render, staticRenderFns } from "./free-installation-audit-add-processremark-modal.vue?vue&type=template&id=85b488a0"
import script from "./free-installation-audit-add-processremark-modal.vue?vue&type=script&lang=js"
export * from "./free-installation-audit-add-processremark-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports